export { Detail } from "./Detail";
